/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { string, any, objectOf, func, object, bool, element } from 'prop-types';
import get from 'lodash/get';
import queryString from 'query-string';
// import SponsorsBand from '../molecules/sponsors-band';
import CardImage from '../atoms/cardimage';
import Footer from '../story/footer/footer';
import Sidebar from '../story/sidebar/sidebar';
import Authors from '../story/authors/authors';
import PublishedInfo from '../story/published-info/published-info';
import Share from '../story/share/share';
import PianoPaywall from '../story/piano-paywall';
import OpinionBadge from '../story/opinion-badge/opinion-badge';
import ShareFloatingExpanded from '../story/share/share-floating-expanded';
import Loader from '../atoms/icons/loader';
import AdWithPlaceholder from '../molecules/ad-with-placeholder';
import { hasSection } from '../../helpers/story-helpers';
import { syndicatedSource, checkCookie, getStaticConfig, getStoryDate } from '../../helpers/utils';
import { trackUserInteraction } from '../../helpers/datalayer-utils';
import { WithLazy } from '@quintype/components';
import BreadcrumbBasic from '../atoms/breadcrumb-basic';
import TrackVisibility from '../track-visibility';
import VideosWidget from '../molecules/videos-widget';
import MailmodoNewsLetter from '../molecules/newsletter/mailmodo-news-letter';
// import TheLatestPiano from '../atoms/the-latest-piano';
import LatestNewsWidget from '../story/latest-news-widget';
// import DavosBand from '../molecules/davos-band';
import { KeyHighlights } from '../molecules/key-highlight';
import { ClockOutlineIcon } from '../atoms/material-icons';
import { isMobile } from 'react-device-detect';
import ContentNotAvailable from '../story/contentnotavailable/contentnotavailable';
import './story-base-template.m.css';
import ExpandVideosWidget from '../story/expand-videos-widget/expand-videos-widget';

const storyShareClickHandler = (storyContentId, storyUrl) => (event) =>
  global.app.registerStoryShare(
    storyContentId,
    event.currentTarget.getAttribute('data-social-media-type'),
    storyUrl
  );

function addLinkToCopy() {
  var bodyElement = document.getElementsByTagName('body')[0];
  var selection = window.getSelection();
  var pagelink =
    "<br /><br /> Read more at: <a href='" +
    document.location.href +
    "'>" +
    document.location.href +
    '</a><br />Copyright &copy; NDTV Profit';
  var copytext = selection.toString().substring(0, 400) + pagelink;
  var newdiv = document.createElement('div');
  newdiv.style.position = 'absolute';
  newdiv.style.left = '-99999px';
  bodyElement.appendChild(newdiv);
  newdiv.innerHTML = copytext;
  selection.selectAllChildren(newdiv);
  window.setTimeout(function () {
    bodyElement.removeChild(newdiv);
  }, 0);
}

const StoryBaseTemplate = (props) => {
  const [isGeoBlock, setIsGeoBlock] = useState(false);
  const sectionSlug = get(props, ['story', 'sections']).map((item) => item.slug);
  const [showFloatingSocial, setShowFloatingSocial] = useState(false);
  // const pushDownAdVisible = useSelector(state => get(state, ['pushDownAdVisible'], false));

  useEffect(() => {
    // TODO: Reset function when unmounting
    document.oncopy = addLinkToCopy;
    const queryObject = queryString.parse(window.location.search);

    if (queryObject.utm_source === 'wru') {
      const datalayerFields = {
        category: 'article page',
        action: 'Recommended for you',
        label: get(props, ['story', 'headline'], ''),
        event: 'event articlepage',
        cd22: 'link',
        cd23: 'bottom more on this topic',
        cd24: 'NA', // element id
        cd26: syndicatedSource(get(props, 'story', null)),
        cd31: get(props, ['story', 'story-template'], 'text'),
        cd35: 'wru',
        cd34: 'NA', // source of the user
      };
      trackUserInteraction(datalayerFields);
    }
    if (window.history.length === 1) {
      const _datalayerFields = {
        event: 'event Back button clicked',
        label: 'back button',
        action: 'click',
      };
      (function (window, location) {
        history.replaceState(null, document.title, location.pathname + '#!/homepage');
        history.pushState(null, document.title, location.pathname);

        window.addEventListener(
          'popstate',
          function () {
            if (location.hash === '#!/homepage') {
              history.replaceState(null, document.title, location.pathname);
              trackUserInteraction(_datalayerFields);
              setTimeout(function () {
                location.replace('https://www.ndtvprofit.com/');
              }, 0);
            }
          },
          false
        );
      })(window, location);
    }

    const GeoTag = checkCookie('GeoTag');
    const syndicatesource = syndicatedSource(props.story);

    // const isDateCheck = isBefore(
    //   new Date(get(props, ['story', 'first-published-at'])),
    //   new Date('05-05-2022')
    // );

    const sources = get(
      getStaticConfig,
      ['integrations', 'geoTag', 'sources'],
      ['Bloomberg', 'businessweek', 'bloomberg']
    );
    const sourceCheck =
      sources.includes(syndicatesource) || sectionSlug.some((val) => sources.includes(val));
    setIsGeoBlock(
      GeoTag &&
      GeoTag !== 'undefined' &&
      GeoTag !== 'IN' &&
      // !isDateCheck &&
      sourceCheck
    );
  }, []);

  const textSelection = !props.textSelectionEnabled ? 'disable-selection' : '';
  const datalayerFields = {
    category: 'article page',
    action: 'NA',
    label: props.story.headline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'NA', // element location
    cd24: 'NA', // element id
    cd26: syndicatedSource(props.story),
    cd31: props.story['story-template'] || 'text',
    cd35: 'NA', // recommendation engine
    cd34: 'NA', // source of the user
  };
  const audioS3Key = get(props, ['story', 'story-audio', 's3-key']);

  const getHeroImageCaption = () => {
    let heroImageCaption =
      get(props, ['story', 'hero-image-caption'], null) ||
      get(
        props,
        ['story', 'alternative', 'home', 'default', 'hero-image', 'hero-image-caption'],
        ''
      );

    heroImageCaption =
      heroImageCaption &&
      heroImageCaption
        .replace(/<div class="paragraphs"><p>/gi, '')
        .split('</p></div>')
        .join(' ')
        .split('<br>')
        .join(' ');

    return heroImageCaption ? (
      <div styleName="hero-image-caption" dangerouslySetInnerHTML={{ __html: heroImageCaption }} />
    ) : (
      <></>
    );
  };

  const PublisherAndSocialShareSection = () => {
    return (
      <div>
        <div styleName="story-content-head-first-fold"></div>
        <div
          styleName={
            props.amazon_polly && audioS3Key
              ? 'story-content-head story-content-head-inc-margin'
              : 'story-content-head'
          }
        >
          <div styleName="author-and-published-time">
            <Authors
              storyId={props.story.id}
              authors={props.story.authors}
              datalayerFields={datalayerFields}
              alt="BQ"
            />
            <span
              styleName="story-published-date"
              dateTime={new Date(props.story['first-published-at'])
                .toISOString()
                .replace('Z', '+05:30')}
            >
              <ClockOutlineIcon size="18px" color="var(--regent-gray)" />
              <span styleName="story-date">{getStoryDate(props.story['last-published-at'])} </span>
              <span className="icon-ic_info_outline" styleName="story-date-info-icon"></span>
              <div styleName="popover-story-dates">
                <PublishedInfo
                  publishedAt={props.story['first-published-at']}
                  updatedAt={props.story['last-published-at']}
                />
              </div>
            </span>
          </div>
          {/* <PublishedInfo
            publishedAt={props.story['first-published-at']}
            updatedAt={props.story['last-published-at']}
          /> */}
          {/* {props.amazon_polly && audioS3Key && (
            <WithMember>
              {({ member, checkForMemberUpdated }) => (
                <AmazonPolly
                  member={member}
                  checkForMemberUpdated={checkForMemberUpdated}
                  hasAccess={!props.partialAccess}
                  story={props.story}
                />
              )}
            </WithMember>
          )} */}

          {/* Social share option beside author details mobile view */}
          {/* <MediaQuery maxWidth={767}>
            <Share
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'linkedin', 'copy']}
              alignType="verticle"
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
            />
          </MediaQuery> */}

          {/* Social share toggle option floating in mobile */}
          {/* <MediaQuery maxWidth={767}>
            <ShareToggle
              showAlways={true}
              storyId={props.story.id}
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram', 'linkedin', 'copy']}
              servicesToShowByDefault={2}
              alignType="verticle"
              showToggleWhenExpanded={false}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
            />
          </MediaQuery> */}

          {/* Social share option beside author details */}
          <div styleName="share-floating-expanded">
            <img
              src="https://images.assettype.com/bloombergquint/2022-12/e39940bc-4ded-4a67-94d3-641e07718d9f/googlenews.png"
              height="37.25px"
              width="135.94"
              alt="google-new-follow"
              onClick={() =>
                window.open(
                  'https://news.google.com/publications/CAAqBwgKMKr0kAsw9JylAw?hl=en-IN&gl=IN&ceid=IN%3Aen',
                  '_blank'
                )
              }
            />
            <Share
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram']}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
              source="story-content-head"
              expanded={true}
              alignType="horizontal"
              showToggleWhenExpanded={false}
              bookmark={props.bookmark}
              storyId={get(props, ['story', 'id'])}
            />
          </div>

          {/* Social share option floating top */}
          {showFloatingSocial ? (
            <ShareFloatingExpanded
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram', 'copy']}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
              storyId={get(props, ['story', 'id'])}
              bookmark={props.bookmark}
              story={props.story}
            />
          ) : null}
        </div>
      </div>
    );
  };

  const isBudgetStory = get(props, ['story', 'sections'])
    .map((item) => item.slug)
    .includes('budget-2023');

  // const isDavosStory = get(props, ['story', 'sections'])
  //   .map(item => item.slug)
  //   .includes('davos-world-economic-forum-2023');

  const isLiveBlog = get(props, ['story', 'story-template']) === 'live-blog';

  // setPostFrom

  // const handleShowFloatingSocial = () => {
  //   if (!pushDownAdVisible) {
  //     setShowFloatingSocial(true);
  //   }
  // };

  // console.log('testing');

  return (
    <>
      <BreadcrumbBasic story={props?.story} />
      {/* {isBudgetStory && <SponsorsBand />} */}
      {/* {isDavosStory && <DavosBand />} */}
      <article id={`story-${props.story.id}`} className="story-page container">
        <div styleName="add-with-grey-background">
          <div className="responsive-ad content-center">
            {!isMobile && (
              <AdWithPlaceholder adtype="AboveArticleHeadline" height="100px" width="728px" />
            )}
          </div>
        </div>
        <div className="responsive-ad content-center">
          {isMobile && !isLiveBlog && !isBudgetStory && (
            <AdWithPlaceholder adtype="AboveHeroImage" height="100px" width="100%" />
          )}
        </div>
        {!isGeoBlock && (
          <>
            <div styleName="story-content" className={textSelection}>
              <div styleName="story-header-text" className="container">
                <h1 styleName="story-headline">{props.story.headline}</h1>

                <div styleName="story-subtext-wrapper">
                  <h3 styleName="story-subtext">{props.story.summary}</h3>
                  {(hasSection(props.story.sections, 'View') ||
                    hasSection(props.story.sections, 'Gadfly') ||
                    hasSection(props.story.sections, 'Opinion')) && (
                      <OpinionBadge story={props.story} />
                    )}
                </div>
                <TrackVisibility
                  onHide={() => setShowFloatingSocial(true)}
                  onVisible={() => setShowFloatingSocial(false)}
                >
                  <div className="dummy-div-for-intersection-obeserver"></div>
                </TrackVisibility>
              </div>
              <div className="container">{PublisherAndSocialShareSection()}</div>
            </div>
          </>
        )}

        <div className="row-section sidebar" styleName="story-except-headline">
          <div styleName="left-sidebar">
            <div className="reddit-card " />
            <div className="reddit-embed" />
            <canvas className="hide-element" width="1" height="1" />
            <object className="hide-element" width="1" height="1" />
            <>
              <div styleName="story-header">
                {!isGeoBlock && (
                  <div styleName="shimmer-card">
                    <div styleName="hero-image-container">
                      <CardImage
                        story={props.story}
                        aspectRatio={[16, 9]}
                        imageType="image5x2"
                        showHeroDetails={true}
                        isLazy={false}
                      />
                      {getHeroImageCaption()}
                    </div>
                  </div>
                )}

                {!isGeoBlock ? (
                  <div styleName="body-container">
                    <div
                      styleName="BelowHeroImage-ad"
                      className="content-center mobile-only"
                      style={{ height: '270px' }}
                    >
                      {isMobile && (
                        <>
                          {isLiveBlog ? (
                            <>
                              <AdWithPlaceholder
                                adtype="LiveBlogBelowHeroImageMob"
                                height="250px"
                                width="300px"
                              />
                            </>
                          ) : (
                            <AdWithPlaceholder
                              adtype="BelowHeadlinemob"
                              height="250px"
                              width="300px"
                            />
                          )}
                        </>
                      )}
                    </div>
                    {isLiveBlog && <KeyHighlights cards={props.story.cards} />}
                    <div
                      id="piano-preview-story"
                      styleName="piano-preview-story"
                      style={{ display: 'none' }}
                    >
                      {props.previewContent}
                    </div>
                    <div className="cXenseParse" id="piano-content-controller">
                      {props.content}
                    </div>
                    {props.isLoading ? (
                      <div styleName="loader-container">
                        <Loader width="66" color="#f86d1a" />
                      </div>
                    ) : (
                      <div />
                    )}
                    <PianoPaywall />
                  </div>
                ) : (
                  <div>
                    <ContentNotAvailable />
                  </div>
                )}
              </div>
            </>
            <div style={{ position: 'sticky', top: '100px', justifyContent: 'center' }}>
              <Footer
                {...props}
                PublisherAndSocialShareSection={PublisherAndSocialShareSection}
                isGeoBlock={isGeoBlock}
              />
              {/* <div styleName="vuukle-ad">
                <AdWithPlaceholder id="vuukle-ad-3" width="300px" height="260px" />
              </div> */}
            </div>
          </div>
          <div className="right-sidebar">
            {!isMobile && (
              <div className="responsive-ad content-center desktop-only">
                {isLiveBlog ? (
                  <div styleName="above-key-highlights">
                    <AdWithPlaceholder adtype="AboveKeyHighlights" height="250px" width="300px" />
                  </div>
                ) : (
                  <div styleName="above-popular">
                    <AdWithPlaceholder adtype="AbovePopular" height="250px" width="300px" />
                  </div>
                )}
              </div>
            )}
            <WithLazy>
              {() => (
                <Sidebar
                  datalayerFields={datalayerFields}
                  story={props.story}
                  mostRead={props.mostRead}
                  isLiveBlog={isLiveBlog}
                />
              )}
            </WithLazy>
          </div>
          <WithLazy>
            {() => (
              <>
                <div className="mobile-only">
                  <MailmodoNewsLetter
                    heading="Get market moving news, top news & compelling perspectives"
                    footerText1="We Promise. No Spam !"
                    footerText2="View All Newsletters"
                    page="story"
                  />
                  <ExpandVideosWidget />
                  <VideosWidget />
                </div>
                <div className="desktop-only" style={{ position: 'relative' }}>
                  <MailmodoNewsLetter
                    heading="Get market moving news, top news & compelling perspectives"
                    footerText1="No Spam. Just great journalism in your inbox"
                    footerText2="View All Newsletters"
                    page="story"
                  />
                </div>
              </>
            )}
          </WithLazy>
          <WithLazy>
            {() => (
              <div styleName="recomended-for-you-piano">
                <LatestNewsWidget story={props.story} />
              </div>
            )}
          </WithLazy>
        </div>
      </article>
    </>
  );
};

StoryBaseTemplate.propTypes = {
  publisherUrl: string.isRequired,
  story: objectOf(any).isRequired,
  content: element.isRequired,
  previewContent: element.isRequired,
  partialContent: element,
  textSelectionEnabled: bool.isRequired,
  cardOrder: string,
  orderChanged: func,
  privateMode: bool.isRequired,
  juspayMicroFlow: bool.isRequired,
  hasAccess: bool,
  member: object,
  isLoading: bool,
  updateAccess: func,
  mostRead: object,
  partialAccess: bool,
  amazon_polly: bool,
  bookmark: bool,
};

StoryBaseTemplate.defaultProps = {
  cardOrder: '',
  orderChanged: () => { },
};

const mapStateToProps = (state) => ({
  publisherUrl: state.qt.config['sketches-host'],
  textSelectionEnabled: state.qt.config.features.story.text_selection.enabled,
  juspayMicroFlow: state.qt.config.features.subscription.juspay_micro,
  amazon_polly: get(state.qt, ['config', 'features', 'amazon_polly', 'enabled'], false),
  bookmark: get(state, ['qt', 'config', 'features', 'bookmark', 'enabled'], false),
});

export default connect(mapStateToProps, {})(StoryBaseTemplate);
